// extracted by mini-css-extract-plugin
module.exports = {"projectContainer":"projectContainer__10w0d","symbol":"symbol__3UBE7","projectTitle":"projectTitle__1O_Zi","skills":"skills__2vr7_"};